module.exports = function (prefix, cnt) {
  return "".concat(prefix, "-").concat(cnt, "-").concat(Math.random().toString(16).slice(3, 8));
};